import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MHVoucher } from 'src/app/interfaces/api/voucher';

@Component({
  selector: 'app-modal-show-payment-detail',
  templateUrl: './modal-show-payment-detail.component.html',
  styleUrls: ['./modal-show-payment-detail.component.scss'],
})
export class ModalShowPaymentDetailComponent implements OnInit {
  @Input() subtotalWeight: number;
  @Input() subtotalPrice: number;
  @Input() selectedVoucher: MHVoucher;
  @Input() totalPrice: number;
  @Input() deliveryFee: number;
  @Input() ppn_price: number = null;
  @Input() ppn_percentage: number = null;
  @Input() transactionId: number;
  @Input() step: number;
  @Input() unique_payment_code: number = null;
  @Input() show_unique_payment_code: boolean;
  @Input() delivery_type: number | null = null;

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  confirm() {
    this.modalController.dismiss(null, 'confirm');
  }
  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  toNumber(str: string) {
    if (!str) {
      return 0;
    }

    return parseFloat(str);
  }
}
